import { useContext } from 'react'

import { SetupContext } from './context'

export function useSetupState() {
  const ctx = useContext(SetupContext)
  if (!ctx) throw new Error('useSetupState must be used within SetupProvider')
  return ctx
}
